import { createThemedUseStyles } from "theme";

export default createThemedUseStyles((theme) => ({
  whiteFont: { color: "white" },
  disabled: { display: "none" }
}));
